export const VISIBILITY_SHIPMENT_LIST_FETCH = "visibility/shipment_list_fetch"
export const VISIBILITY_SHIPMENT_LIST_FETCH_SUCCESS =
    "visibility/shipment_list_fetch_success"
export const VISIBILITY_SHIPMENT_LIST_FETCH_FAILURE =
    "visibility/shipment_list_fetch_failure"

export const VISIBILITY_SHIPPER_TRACK_DETAILS_FETCH_SUCCESS =
    "visibility/shipper_track_details_fetch_success"
export const VISIBILITY_SHIPPER_TRACK_DETAILS_FETCH_FAILURE =
    "visibility/shipper_track_details_fetch_failure"

export const VISIBILITY_SHIPPER_FILTER_VALUES_FETCH =
    "visibility/shipper_filter_values_fetch"
export const VISIBILITY_SHIPPER_FILTER_VALUES_FETCH_SUCCESS =
    "visibility/shipper_filter_values_fetch_success"
export const VISIBILITY_SHIPPER_FILTER_VALUES_FETCH_FAILURE =
    "visibility/shipper_filter_values_fetch_failure"

export const VISIBILITY_FETCH_COMMENTS = "visibility/fetch_comments"
export const VISIBILITY_FETCH_COMMENTS_SUCCESS =
    "visibility/fetch_comment_success"
export const VISIBILITY_POST_COMMENT = "visibility/post_comment"
export const VISIBILITY_POST_COMMENT_SUCCESS = "visibility/post_comment_success"

export const VISIBILITY_REJECT_REASONS_FETCH =
    "visibility/reject_reasons_fetch_data"
export const VISIBILITY_REJECT_REASONS_FETCH_SUCCESS =
    "visibility/reject_reasons_fetch_data_success"
export const VISIBILITY_REJECT_REASONS_FETCH_FAILURE =
    "visibility/reject_reasons_fetch_data_failure"

export const VISIBILITY_SAVE_ACTION_CODE = "visibility/save_action_code__data"
export const VISIBILITY_SAVE_ACTION_CODE_SUCCESS =
    "visibility/save_action_code__data_success"
export const VISIBILITY_SAVE_ACTION_CODE_FAILURE =
    "visibility/save_action_code__data_failure"

export const LAZY_LOAD_SHIPMENTS_PAGEINFO =
    "visibility/lazy_load_shipments_page_info"

export const UPDATE_SELECTED_EQUIPMENTS =
    "visibility/update_selected_equipments"
export const CLEAR_SELECTED_EQUIPMENTS = "visibility/clear_selected_equipments"
export const SET_EXTRACTION_DATE = "visibility/set_extraction_date"
export const SET_EXTRACTION_NUMBER = "visibility/set_extraction_number"
export const SHIPMENTS_PAGEINFO = "visibility/shipments_page_info"

export const VISIBILITY_WAYBILL_INFORMATION_FETCH =
    "visibility/fetch_waybill_info"
export const VISIBILITY_WAYBILL_INFORMATION_FETCH_SUCCESS =
    "visibility/fetch_waybill_info_success"
export const VISIBILITY_RAILCAR_MOVEMENTS_FETCH =
    "visibility/fetch_railcar_movement"
export const VISIBILITY_RAILCAR_MOVEMENTS_FETCH_SUCCESS =
    "visibility/fetch_railcar_movement_success"
export const VISIBILITY_GET_CAR_SCHEDULING_RAILCAR_MOVEMENTS =
    "visibility/get_car_scheduling_railcar_movements"
export const VISIBILITY_GET_CAR_SCHEDULING_RAILCAR_MOVEMENTS_SUCCESS =
    "visibility/get_car_scheduling_railcar_movements_success"
export const VISIBILITY_SHIPMENT_WAYBILL_FETCH =
    "visibility/fetch_shipment_waybill"
export const VISIBILITY_SHIPMENT_WAYBILL_FETCH_SUCCESS =
    "visibility/fetch_shipment_waybill_success"

export const VISIBILITY_CLEAR_WAYBILL = "visibility/clear_waybill"

export const VISIBILITY_GET_EBOL_TOKEN = "visibility/get_ebol_token"
export const VISIBILITY_GET_EBOL_TOKEN_SUCCESS =
    "visibility/get_ebol_token_success"
export const VISIBILITY_GET_EBOL_TOKEN_FAILURE =
    "visibility/get_ebol_token_failure"

export const SELECT_CARS_IN_ACTIONS = "visibility/select_cars_in_actions"

export const CLEAR_VISIBILITY_ALL = "visibility/clear_all"

export const SET_RAILROAD_DATE = "visibility/set_railroad_date"
export const PLATFORM_SERVICE_FETCH = "visibility/platform_service_fetch"
export const PLATFORM_SERVICE_FETCH_SUCCESS =
    "visibility/platform_service_fetch_success"
export const PLATFORM_SERVICE_FETCH_FAILURE =
    "visibility/platform_service_fetch_failure"

export const PLATFORM_SERVICE_FETCH_CLEAR =
    "visibility/platform_service_fetch_clear"

export const SEET_DATE_RANGE_TMS = "visibility/set_date_range_tms"
export const SEET_DATE_RANGE_TELEGRAPH = "visibility/set_date_range_TELEGRAPH"
